import { useState, useEffect } from "react";
import Modal from "react-modal";
import Swal from "sweetalert2";
import { addDoc, serverTimestamp } from "firebase/firestore";
import { getAuth } from "firebase/auth";
import { getSubCollection } from "../utils/getSubCollection";

const modalStyles = {
  content: {
    top: "50%",
    left: "50%",
    right: "auto",
    bottom: "auto",
    transform: "translate(-50%, -50%)",
    width: "90%",
    maxWidth: "400px",
    padding: "24px",
    borderRadius: "8px",
    backgroundColor: "#fff",
    boxShadow: "0 6px 12px rgba(0, 0, 0, 0.15)",
    border: "none",
    fontFamily: "Inter, sans-serif",
  },
  overlay: {
    backgroundColor: "rgba(0, 0, 0, 0.5)",
    zIndex: 1008,
  },
};

export default function VendedorModal({
  isOpen,
  onClose,
  onSelect, // callback(vendedor)
}) {
  const [nombre, setNombre] = useState("");
  const [correo, setCorreo] = useState("");

  // Limpiar campos al abrir
  useEffect(() => {
    if (isOpen) {
      setNombre("");
      setCorreo("");
    }
  }, [isOpen]);

  const handleSave = async (e) => {
    e.preventDefault();
    if (!nombre.trim()) {
      return Swal.fire("¡Error!", "El nombre no puede quedar vacío.", "error");
    }
    try {
      // UID del usuario autenticado
      const auth = getAuth();
      const ownerId = auth.currentUser.uid;

      const data = {
        ownerId,
        nombre: nombre.trim(),
        correo: correo.trim(),
        registrado: true,
        creadoEn: serverTimestamp(),
      };

      // Subcolección /usuarios/{ownerId}/vendedores
      const vendedoresCol = getSubCollection(ownerId, "vendedores");
      const docRef = await addDoc(vendedoresCol, data);

      Swal.fire({
        icon: "success",
        title: "Vendedor agregado",
        timer: 1200,
        showConfirmButton: false,
      });

      onSelect({ id: docRef.id, ...data });
      onClose();
    } catch (error) {
      console.error(error);
      Swal.fire("Error", error.message, "error");
    }
  };

  return (
    <Modal isOpen={isOpen} onRequestClose={onClose} style={modalStyles}>
      <h2 style={{ textAlign: "center", marginBottom: 20 }}>
        Agregar Vendedor
      </h2>

      <form
        onSubmit={handleSave}
        style={{ display: "flex", flexDirection: "column", gap: 20 }}
      >
        <div style={{ display: "flex", flexDirection: "column" }}>
          <label style={{ marginBottom: 6, fontWeight: 500 }}>Nombre</label>
          <input
            type="text"
            value={nombre}
            onChange={(e) => setNombre(e.target.value)}
            placeholder="Ingresa nombre completo"
            style={{
              width: "100%",
              padding: "10px 12px",
              borderRadius: 6,
              border: "1px solid #ccc",
              fontSize: "16px",
              boxSizing: "border-box",
            }}
          />
        </div>

        <div style={{ display: "flex", flexDirection: "column" }}>
          <label style={{ marginBottom: 6, fontWeight: 500 }}>Correo</label>
          <input
            type="email"
            value={correo}
            onChange={(e) => setCorreo(e.target.value)}
            placeholder="usuario@dominio.com"
            style={{
              width: "100%",
              padding: "10px 12px",
              borderRadius: 6,
              border: "1px solid #ccc",
              fontSize: "16px",
              boxSizing: "border-box",
            }}
          />
        </div>

        <div style={{ display: "flex", justifyContent: "flex-end", gap: 12 }}>
          <button
            type="button"
            onClick={onClose}
            style={{
              background: "#6c757d",
              color: "#fff",
              padding: "10px 16px",
              border: "none",
              borderRadius: 6,
              cursor: "pointer",
              fontSize: "14px",
            }}
          >
            Cancelar
          </button>
          <button
            type="submit"
            style={{
              background: "#007bff",
              color: "#fff",
              padding: "10px 16px",
              border: "none",
              borderRadius: 6,
              cursor: "pointer",
              fontSize: "14px",
            }}
          >
            Guardar
          </button>
        </div>
      </form>
    </Modal>
  );
}
